export const filterButtons = (activeButton) => [
  {
    disabled: activeButton === 'discpads',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'discpads',
    text: 'Дисковые',
    id: 2,
  },
  {
    disabled: activeButton === 'drumpads',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'drumpads',
    text: 'Барабанные',
    id: 5,
  },
];
